// Parse KHỐI của nội dung bài Kênh Cộng Đồng (markdown-lite v2, theo dòng):
//   `## Tiêu đề` | `- gạch đầu dòng` | `1. danh sách số` | `---` kẻ ngang |
//   `![2]` ảnh thứ 2 của bài chèn tại vị trí đó.
// Dòng còn lại gộp thành đoạn văn (giữ xuống dòng bên trong đoạn).
//
// Luật copy từ mobile/src/modules/community-channel/utils/community-content-blocks.ts
// (CRA riêng nên không import chéo được). Sửa ở đây PHẢI sửa cả mobile +
// frontend/src/pages/Community/community-content-blocks.js.

const HEADING_REGEX = /^#{2,3}\s+(.*)$/;
const BULLET_REGEX = /^[-•]\s+(.*)$/;
const NUMBERED_REGEX = /^(\d{1,2})[.)]\s+(.*)$/;
const DIVIDER_REGEX = /^-{3,}$/;
const IMAGE_REF_REGEX = /^!\[(\d{1,2})\]$/;

/**
 * @param {string} content
 * @returns {Array<{type: string, text?: string, order?: number, imageIndex?: number}>}
 */
export function parseContentBlocks(content) {
    if (!content) return [];
    const blocks = [];
    let paragraph = [];

    const flushParagraph = () => {
        if (!paragraph.length) return;
        const text = paragraph.join("\n");
        if (text.trim()) blocks.push({ type: "paragraph", text });
        paragraph = [];
    };

    String(content)
        .split("\n")
        .forEach((rawLine) => {
            const line = rawLine.trim();

            if (DIVIDER_REGEX.test(line)) {
                flushParagraph();
                blocks.push({ type: "divider" });
                return;
            }
            const image = line.match(IMAGE_REF_REGEX);
            if (image) {
                flushParagraph();
                blocks.push({ type: "image", imageIndex: Number(image[1]) });
                return;
            }
            const heading = line.match(HEADING_REGEX);
            if (heading) {
                flushParagraph();
                blocks.push({ type: "heading", text: heading[1] });
                return;
            }
            const bullet = line.match(BULLET_REGEX);
            if (bullet) {
                flushParagraph();
                blocks.push({ type: "bullet", text: bullet[1] });
                return;
            }
            const numbered = line.match(NUMBERED_REGEX);
            if (numbered) {
                flushParagraph();
                blocks.push({ type: "numbered", text: numbered[2], order: Number(numbered[1]) });
                return;
            }
            paragraph.push(rawLine);
        });

    flushParagraph();
    return blocks;
}

/** Vị trí ảnh (1-based) đã chèn giữa nội dung — không lặp lại ở lưới ảnh cuối bài */
export function getInlineImageIndexes(content) {
    return parseContentBlocks(content)
        .filter((b) => b.type === "image")
        .map((b) => b.imageIndex);
}
